<template>
  <div ref="container">
    <a-modal :title="title" :width="1500" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container"
             :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             :ok-button-props="{ disabled: true }" @ok="handleOk" @cancel="handleCancel"  style="top:10%;height: 80%;">
      <template slot="footer">
        <a-button key="back"  @click="handleCancel">
          关闭
        </a-button>
        <a-button key="back" :disabled="isReadOnly" @click="handleOk" type="primary">
          确定
        </a-button>
      </template>
      <a-spin :spinning="confirmLoading">
        <a-card>
          <span class="title">产品标识信息</span>
          <a-descriptions class="description">
            <a-descriptions-item label="产品DI" v-if="productSign.di">{{productSign.di}}</a-descriptions-item>
            <a-descriptions-item label="产品标识体系编码名称" v-if="productSign.codeSystem">{{productSign.codeSystem == '1' ? 'MA(IDcode)' : 'GS1'}}</a-descriptions-item>
            <a-descriptions-item label="产品名称" v-if="productSign.diMessage.productName">{{productSign.diMessage.productName}}</a-descriptions-item>
            <a-descriptions-item label="分类编码" v-if="productSign.diMessage.categoryCode">{{productSign.diMessage.categoryCode}}</a-descriptions-item>
            <a-descriptions-item label="包装规格" v-if="productSign.diMessage.specificationModel">
              {{productSign.diMessage.specificationModel}}
            </a-descriptions-item>
            <a-descriptions-item label="器械类别" v-if="productSign.diMessage.deviceCategory">
              <span v-if="productSign.diMessage.deviceCategory == 1">器械</span>
              <span v-else-if="productSign.diMessage.deviceCategory == 2">体外诊断试剂</span>
            </a-descriptions-item>
          </a-descriptions>

        </a-card>
        <a-card style="margin-top:30px;">
          <span class="title">产品PI信息</span>
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isBatchNumber === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产批号" prop="batchNumber">
                  <a-input style="width:90%;" placeholder="请输入生产批号" v-model="form.batchNumber" @blur="getPIInfo"/>
                  <a-tooltip placement="right" title="请输入生产批号，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isSerialNumber === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号长度" prop="serialLength">
                  <a-input style="width:90%;" placeholder="请输入序列号长度" v-model="form.serialLength" />
                  <a-tooltip placement="right" title="请输入序列号，最大值不能超过25，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isSerialNumber === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列起始号" prop="serialStartNum">
                  <a-input style="width:90%;" placeholder="请输入序列号起始号" v-model="form.serialStartNum" />
                  <a-tooltip placement="right" title="请输入序列号起始号，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isSerialNumber === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="步长" prop="step">
                  <a-input style="width:90%;" placeholder="请输入步长" v-model="form.step" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/3"  v-if="this.form && this.form.diMessage && this.form.diMessage.isSerialNumber === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生码数量" prop="codeNum">
                  <a-input style="width:90%;" placeholder="请输入生码数量" v-model="form.codeNum" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isSerialNumber === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号前缀" prop="serialPrefix">
                  <a-input style="width:90%;" placeholder="请输入序列号前缀" v-model="form.serialPrefix" />
                  <a-tooltip placement="right" title="请输入序列号前缀，'序列号前缀 + 序列号起始值 + 生码数量 * 步长'获取的值的长度最大不能超过序列号长度">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="24/2">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号终止号" prop="serialEndNum">
                  <a-input style="width:90%;" placeholder="请输入序列号终止号" v-model="form.serialEndNum" />
                  <a-tooltip placement="right" title="请输入序列号终止号，仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col> -->
              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isStartDate === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产日期" prop="startDate">
                  <j-date v-model="form.startDate" dateFormat="YYYY-MM-DD" placeholder="请输入选择生产日期" :show-time="true"  @change="(date)=>handleDateChange(date, 'startDate')"/>
                </a-form-model-item>
              </a-col>
              
              <a-col :span="24/3" v-if="this.form && this.form.diMessage && this.form.diMessage.isEndDate === true ">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="失效日期" prop="endDate">
                  <j-date v-model="form.endDate" dateFormat="YYYY-MM-DD" placeholder="请输入选择失效日期" :show-time="true" @change="(date)=>handleDateChange(date, 'endDate')"/>
                </a-form-model-item>
              </a-col>
               <a-col :span="24/3">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效日期" prop="effectiveDate">
                  <j-date v-model="form.effectiveDate" dateFormat="YYYY-MM-DD" placeholder="请输入选择有效日期" :show-time="true" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/3" v-if="showSterilizationBatch">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="灭菌批号" prop="dBatchNumber">
                  <a-input style="width:90%;" placeholder="请输入灭菌批号" v-model="form.dBatchNumber" />
                  <a-tooltip placement="right" title="请输入灭菌批号,仅支持数字">
                    <a-icon type="question-circle" style="margin-left:5px" />
                  </a-tooltip>
                </a-form-model-item>
              </a-col>

            </a-row>
          </a-form-model>
        </a-card>
        <a-card style="margin-top: 10px">
          <a-col :col="24" v-if="level !== Number(this.form.packageLevel)">
            <a-checkbox style="margin: 0px 0 10px 60px;">
              <span style="font-size:16px;">同步生成上级包装PI编码</span>
              <a-tooltip placement="right" title="使用此功能，上级码生数据及规则将沿用本页面内容">
                <a-icon type="question-circle" style="margin-left:5px" />
              </a-tooltip>
            </a-checkbox>
          </a-col>
          <a-col :span="24/3" v-if="(level === 1 && this.form.packageLevel === '0') || (level === 2 && this.form.packageLevel === '0')">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="一级包装生码数量" prop="firstLevelNum">
              <a-input style="width:90%;" placeholder="请输入一级包装生码数量" v-model="form.firstLevelNum" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24/3" v-if="(level === 2 && (this.form.packageLevel === '0' || this.form.packageLevel === '1'))">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="二级包装生码数量" prop="secondLevelNum">
              <a-input style="width:90%;" placeholder="请输入二级包装生码数量" v-model="form.secondLevelNum" />
            </a-form-model-item>
          </a-col>
        </a-card>

      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import JDate from '@/components/jeecg/JDate'
import { addPIinfo, getCreatedMes, insertProductPI } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'moment';
export default {
  name: 'VendorModal',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JDate,
  },
  props:{
    productInfo:{
      type: String,
    }
  },
  data() {
    var checkSerial = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (!/^[0-9]{1,9}$/g.test(value)) {
        // /^[0-9]{1,10}$/g
        return callback(new Error('最多只能输入9位数字'))
      } else {
        callback()
      }
    }
    var checkSerialLength = (rule, value, callback) => {
      if (!value) {
        // 如果值为空，则不进行验证，直接通过
        callback();
      } else if (!/^[1-9][0-9]*$/.test(value)) {
          // 检查是否为正整数
          return callback(new Error('请输入正整数'));
      } else if (parseInt(value) > 25) {
          // 检查是否超过 25
          return callback(new Error('输入的正整数不能超过 25'));
      } else {
          // 验证通过
          callback();
      }
    }

    var checkPrefix = (rule, value, callback) => {
      // const maxLength = this.form.serialPrefix + Number(this.form.serialStartNum) + this.form.codeNum * this.form.step;
      const preValue = Number(this.form.serialStartNum) + Number(this.form.codeNum * this.form.step)
      const maxLength = this.form.serialPrefix + preValue;
      console.log(maxLength.length,this.form.serialLength,'maxLength')
      if (!value) {
        callback()
      } else if (!/^[A-Za-z0-9]+$/.test(value)) {
        return callback(new Error('请输入正整数或字母！'));
      } else if ( maxLength.length > this.form.serialLength ) {
        return callback(new Error(`输入长度不能超过 ${this.form.serialLength} 位`))
      } else {
        callback()
      }
    }
    var checkBatch = (rule, value, callback) => {
      if (value && !/^[A-Za-z0-9-@$,*+%#!^~]{1,20}$/g.test(value)) {
        return callback(new Error('最多只能输入20位字母、数字或字符'))
      } else {
        callback()
      }
    }
    var checkStep = (rule, value, callback) => {
      if (!value) {
        callback()
      } else if (value && !/^[0-9]{1,10}$/g.test(value)) {
        return callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }
    return {
      title: '生成PI',
      visible: false,
      fileList: [],
      model: {},
      headers: { 'X-Access-Token': '123' },
      isReadOnly: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      showSterilizationBatch: false,
      confirmLoading: false,
      specificationId: '',
      form: {
        serialLength: '',
        serialPrefix: '',
        serialStartNum: null,
        serialEndNum: '',
        startDate: '',
        batchNumber: '',
        dBatchNumber: '',
        endDate: '',
        effectiveDate: '',
        codeSystem: '',
        codeNum: null,
        step: null,
        expiryNum: ''
      },
      productSign: {
        di: '',
        codeSystem: '',
        productName: '',
        categoryCode: '',
        specificationModel: '',
        deviceCategory: '',
      },
      level: null,
      queryform: {},
      packageLevel: 0,
      rules: {
        serialLength: [
          {
            required: false,
            validator: checkSerialLength,
            // message: '请选择生产日期',
            trigger: 'blur',
          },
        ],
        serialPrefix: [
          {
            required: false,
            validator: checkPrefix,
            trigger: 'blur',
          },
        ],
        step: [
          {
            required: false,
            validator: checkStep,
            trigger: 'blur',
          },
        ],
        codeNum: [
          {
            required: false,
            validator: checkStep,
            trigger: 'blur',
          },
        ],
        serialStartNum: [
          {
            required: false,
            validator: checkSerial,
            trigger: 'blur',
          },
        ],
        serialEndNum: [
          {
            required: false,
            validator: checkSerial,
            trigger: 'blur',
          },
        ],
        startDate: [
          {
            required: false,
            message: '请选择生产日期',
            trigger: 'change',
          },
        ],
        batchNumber: [
          {
            required: false,
            validator: checkBatch,
            // message: '生产批号不能为空',
            trigger: 'blur',
          },
        ],
        dBatchNumber: [
          {
            required: false,
            validator: checkBatch,
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {},
  methods: {
    handleDateChange(date, type) {
      // 使用 moment.js 格式化日期
      // this.form.startDate = moment(date).format('YYYY-MM-DD');
      // 当生产日期变化时处理逻辑
      if (type === 'startDate') {
        if (!date) {
          this.form.startDate = '';
          this.form.endDate = '';
          return;
        }
        const startDate = moment(date);
        this.form.startDate = startDate.format('YYYY-MM-DD');
        // 计算失效日期逻辑
        if (this.form.expiryNum && Number(this.form.expiryNum) > 0) {
          // 有有效期天数时，按天数相加
          this.form.endDate = startDate.add(this.form.expiryNum, 'days').format('YYYY-MM-DD');
        } else {
          // 无有效期天数时默认加1年
          this.form.endDate = startDate.add(1, 'year').format('YYYY-MM-DD');
        }
      }
    },
    async getPIInfo(specificationId){
      const params = {
        batchNumber: this.form.batchNumber || '',
        specificationId: this.specificationId || specificationId,
      }
      const res = await getCreatedMes(params)
      console.log(res,'获取的PI数据res======================')
      if( res.code == 200 && res.success == true ){
        // const oldBatchNumber = this.form.batchNumber
        this.form = res.result
        this.productSign = res.result
        if( res.result.diMessage.isSerialNumber === false ){
          this.form.serialStartNum = null
        }

        // this.form.batchNumber = oldBatchNumber
        this.form.batchNumber = res.result.batchNumber
        this.form.expiryNum = res.result.expiryNum
        // this.form.codeSystem === '2' || res.result.diMessage.isAseptic === false
        if( res.result.diMessage.isAseptic === false ){
          this.showSterilizationBatch = false
        } else {
          this.showSterilizationBatch = res.result.diMessage.isAseptic === true;
        }

      }
    },
    // 如果月或日小于10,在前面补0
    padZero(num) {
      return num < 10 ? "0" + num : num;
    },
    alldatatoshut(val){
      // 获取年、月、日
      let year = val.getFullYear();
      let month = val.getMonth() + 1; // 月份从0开始,所以需要加1
      let day = val.getDate();

      // 格式化日期为 YYYY-MM-DD 的形式
      let formattedDate = year + "-" + this.padZero(month) + "-" + this.padZero(day);

      return formattedDate
    },
    add(record, level) {
      console.log('传递的record值=================',record, level)
      // this.productSign = this.productInfo
      this.level = level // 传过来的最高包装级别
      this.specificationId = record.id
      this.packageLevel = record.packageLevel
      console.log('packageLevel=================',this.packageLevel)
      this.edit(record)
      // this.form = record
      this.getPIInfo(this.specificationId)

    },
    async edit(record) {

      this.isReadOnly = false
      if (this.$refs.form !== undefined) this.$refs.form.resetFields()
      this.visible = true
      if (record.id && record.specificationId) {
        this.queryform = {
          productId: record.id,
          specificationId: record.specificationId,
        }
        const res = await addPIinfo(this.queryform)
        if (res.errno == 200 && res.errmsg === '成功') {
          console.log(res.data)
          if(res.data.specificationName?res.data.specificationName.split(':')[1]:''){
            const number = res.data.specificationName.split(':')[1]
            if(number == '0'){
              res.data.serialLength = 5
            }else if(number == '1'){
              res.data.serialLength = 4
            }else if(number == '2'){
              res.data.serialLength = 3
            }
            res.data.serialStartNum = null
          }

          //默认生产日期
          res.data.startDate = this.alldatatoshut(new Date())

          //默认失效日期
          const endDate = new Date()
          endDate.setFullYear(endDate.getFullYear() + 1);
          res.data.endDate = this.alldatatoshut(endDate)

          //默认有效日期
          const effectiveDate = new Date()
          effectiveDate.setFullYear(effectiveDate.getFullYear() + 1);
          effectiveDate.setDate(effectiveDate.getDate() - 1);
          res.data.effectiveDate = this.alldatatoshut(effectiveDate)

          this.form = res.data
        } else {
          this.$message.error(res.errmsg)
        }
      }
      this.$nextTick(() => {})
    },

    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      that.$refs['form'].validate(async (success) => {
        if (success === true) {

          if(this.form.serialStartNum > this.form.serialEndNum){
            this.$message.warning('起始数值不能大于终止数值')
            return false
          }
          const isSerialNumberData={
            serialPrefix: this.form.serialPrefix || '',
            serialLength: this.form.serialLength || '',
            step: this.form.step || '',
            serialStartNum: this.form.serialStartNum || '',
            serialEndNum: this.form.serialEndNum || '',
            codeNum: this.form.codeNum || '',
          }
          const params = {
            productId: this.productSign.productId,
            specificationId: this.specificationId,
            codeSystem: this.productSign.codeSystem || '',
            di: this.productSign.productDi || '',
            startDate: this.form.diMessage.isStartDate ? this.form.startDate || '': null,
            effectiveDate: this.form.effectiveDate || '',
            batchNumber:  this.form.diMessage.isBatchNumber ? this.form.batchNumber || '': null,
            dBatchNumber: this.showSterilizationBatch ? this.form.dBatchNumber || '' : null,
            endDate: this.form.diMessage.isEndDate ? this.form.endDate || '' : null,
            firstLevelNum: this.form.firstLevelNum || '',
            secondLevelNum: this.form.secondLevelNum|| '',
          }
          const paramsData = this.form.diMessage.isSerialNumber ? {...params, ...isSerialNumberData} : params
          this.isReadOnly = true
          const res = await insertProductPI(paramsData)

          if (res.code == 200 && res.success === true) {
            this.$message.success(res.message)
            this.visible = false
            this.form = {}
            this.productSign.codeSystem = ''
            this.productSign.productDi = ''
            this.productSign.productId = ''
            this.close()
            this.$emit('ok')
          } else {
            this.isReadOnly = false
            this.$message.error(res.message)
          }
        }
      })
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
.title {
  /* /* margin-left: 30px; */
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 10px;
}
.description /deep/.ant-descriptions-item-content {
  width: 260px !important;
}
</style>
